<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <select class="form-control mb-4" name="standardFilter" id="standardFilter" v-model="standardFilter">
              <option value="" selected disabled>Choisir un standard -></option>
              <option v-for="statdard in standards" :key="statdard.id" :value="statdard.id">
                {{ statdard.code }} - {{ statdard.name }}
            </option>
            </select>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Standard</h6>
                <a class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" v-on:click="saveStandard" v-bind:disabled="addStandardProcess || editStandardProcess || deleteStandardProcess"><i class="fas fa-save fa-md"></i> Enregistrer</a>
              </div>
              <div class="card-body">
                <textarea
                    id="standardEdit"
                    class="form-control"
                    rows="30"
                    style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 5px;"
                >{{ JSON.stringify(standard[0], null, 2) }}</textarea>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      standard: {},
      standardFilter: '',
      indexStandard: '',
      standards: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addStandardProcess: false,
      viewStandardProcess: false,
      editStandardProcess: false,
      deleteStandardProcess: false,
      dTableStandard: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {

      }, 50)
    },
    //Sélectionner tous les Standards (Base de données)
    getStandards () {
      axios.get(this.apiUrl+'/standards', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.standards = res.data
          this.progress += 1
          if (this.progress === 1) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //save standard
    async saveStandard() {
      try {
          const standardEdit = JSON.parse($("#standardEdit").val());
          $('[data-loader="circle-side"]').fadeIn();
          $('#preloader').delay(350).fadeIn('slow');

          const response = await axios.put(
              `${this.apiUrl}/standards/${this.standard[0].id}`,standardEdit, {headers: { 'Authorization': `Bearer ${this.token}` }}
          );

          if (response.status == 200) {
              Swal.fire({
                  icon: 'success',
                  title: 'Succès',
                  text: 'L’enregistrement a été modifié avec succès.',
                  timer: 3000,
                  showConfirmButton: false
              });
          }
      } catch (error) {
          console.error("Erreur lors de l'enregistrement :", error);
          Swal.fire({
              icon: 'error',
              title: 'Erreur',
              text: 'Une erreur s’est produite lors de l’enregistrement.',
              timer: 3000,
              showConfirmButton: false
          });
      } finally {
          $('[data-loader="circle-side"]').fadeOut();
          $('#preloader').delay(350).fadeOut('slow');
      }
  }

  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getStandards()
  },
  watch: {
    loading: function () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    },
    standardFilter: function (val) {
      var standards = this.standards
      this.standard = standards.filter(item => item.id == val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Standard.vue